import { render, staticRenderFns } from "./Cotejo.vue?vue&type=template&id=73cb652e"
import script from "./Cotejo.vue?vue&type=script&lang=js"
export * from "./Cotejo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cb652e')) {
      api.createRecord('73cb652e', component.options)
    } else {
      api.reload('73cb652e', component.options)
    }
    module.hot.accept("./Cotejo.vue?vue&type=template&id=73cb652e", function () {
      api.rerender('73cb652e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/Cotejo.vue"
export default component.exports